// extracted by mini-css-extract-plugin
module.exports = {"logo":"src-hellosign-components-app-logo-v2-styles__logo--1BXhn"};